<template>
  <div class="col-md-6 col-sm-8 col-md-offset-3 col-sm-offset-2">
    <div id="environment-ribbon" :class="'banner-' + getEnvironment()">
      {{ getEnvironmentText() }}
    </div>
    <form method="#" action="#" @click="serverError = ''">
      <div class="card" data-background="color" data-color="blue">
        <div class="card-header">
          <h3 class="card-title pull-left">Account Setup</h3>
          <router-link class="btn btn-fill btn-wd pull-right" to="/"><i class="ti-arrow-left"></i> Back to Login</router-link>
        </div>
        <br><br>
        <div class="card-content">
          <div class="form-group">
            <label>Tribal ID <small>(Numbers Only)</small></label>
            <input type="text" placeholder="Personal Tribal ID"
            name="tribalId"
            v-validate="modelValidations.tribalId"
            v-model.lazy="model.tribalId"
            class="form-control input-no-border">
            <small class="text-danger" v-show="tribalId.invalid">
                {{ getError('tribalId') }}
            </small>
          </div>
          <div class="form-group">
            <label>Birthdate</label><br>
            <el-date-picker
              name="birthdate"
              v-validate="modelValidations.birthdate"
              v-model="model.birthdate"
              type="date"
              placeholder="YYYY-MM-DD"
              :editable="false"
              :default-value="new Date().getFullYear() - 12 + '-01-01'">
            </el-date-picker>
            <small class="text-danger" v-show="birthdate.invalid">
                {{ getError('birthdate') }}
            </small>
          </div>
          <div class="form-group">
            <label>Last 4 Digits of Social Security Number</label>
            <input type="number" placeholder="XXXX"
            name="ssn"
            v-validate="modelValidations.ssn"
            v-model.lazy="model.ssn"
             class="form-control input-no-border">
            <small class="text-danger" v-show="ssn.invalid">
                {{ getError('ssn') }}
            </small>
          </div>
          <div class="form-group">
            <label>E-mail (required if going paperless)</label>
            <input type="text" placeholder="Email Address"
            name="email"
            v-validate="modelValidations.email"
            v-model.lazy="model.email"
            class="form-control input-no-border">
            <small class="text-danger" v-show="email.invalid">
                {{ getError('email') }}
            </small>
          </div>
          <p-checkbox v-model="model.statementEmails" @change="updateEmailValidation()">
            Go paperless and receive statements online only<br>
            <small>By checking this box you agree to the terms in our <a href="static/files/PFTC_Online_Portal_Paperless_Disclosure.pdf" target="_blank">Paperless Disclosure</a></small>
          </p-checkbox>
          
          <div class="form-group">
            <label>New Account Password</label>
            <div class="input-group">
              <input :type="!showPassword ? 'password' : 'text'" placeholder="Password"
              name="password"
              v-validate="modelValidations.password"
              v-model.lazy="model.password"
              class="form-control input-no-border">
              <span class="input-group-btn">
                <button @click.prevent="showPassword=!showPassword"  type="button" tabindex="-1" class="btn form-btn"
                v-html="passwordButton" >
                </button>
              </span>
            </div>
            <small class="text-danger" v-show="password.invalid">
                {{ getError('password') }}
            </small>
          </div>
          <div class="form-group">
            <label>Repeat Account Password</label>
            <input :type="!showPassword ? 'password' : 'text'" placeholder="Repeat Password"
            name="passwordRepeat"
            v-validate="modelValidations.passwordRepeat"
            v-model="model.passwordRepeat"
            class="form-control input-no-border">
            <small class="text-danger" v-show="passwordRepeat.invalid">
                {{ getError('passwordRepeat') }}
            </small>
          </div>
        </div>
        <div class="card-footer text-center">
          <button  type="submit" @click.prevent="validate" class="btn btn-fill btn-wd"><i class="ti-lock"></i> Setup Account</button><br><br>
          <transition name="fade" mode="out-in"><p class="alert alert-danger" v-if="serverError">{{ serverError }}</p></transition>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapFields } from 'vee-validate'
  import { DatePicker } from 'element-ui'
  import viewClientMethod from 'src/components/Dashboard/Views/Dashboard/ViewClient'
  import accountSelectorMethod from 'src/components/Dashboard/Views/Home/Forms/AccountSelector'

  export default {
    components: {
      [DatePicker.name]: DatePicker
    },
    computed: {
      ...mapFields(['tribalId', 'birthdate', 'ssn', 'email', 'password', 'passwordRepeat']),
      passwordButton () {
        return this.showPassword ? '<i class="ti-lock"></i> Hide' : '<i class="ti-eye"></i> Show'
      }
    },
    data () {
      return {
        showPassword: false,
        model: {
          tribalId: '',
          birthdate: '',
          ssn: '',
          email: '',
          statementEmails: false,
          password: '',
          passwordRepeat: ''
        },
        serverError: '',
        modelValidations: {
          tribalId: {
            required: true,
            alpha_num: true
          },
          birthdate: {
            required: true
          },
          ssn: {
            required: true,
            length: 4,
            decimal: false
          },
          email: {
            email: true
          },
          password: {
            required: true,
            min: 6
          },
          passwordRepeat: {
            confirmed: 'password',
            required: true
          }
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      // 0000268: Users can go paperless without providing an email address.
      // On Go Paperless changes, re-run the validation for the email address.
      // Otherwise previous validation failures will continue to be shown when
      // it is blank and Go Paperless has been unselected (which is valid).
      updateEmailValidation () {
        this.$validator.fields.find({name: 'email'}).rules.required = this.model.statementEmails
        this.$validator.validate('email')
      },
      validate () {
        this.serverError = false
        // 0000268: Users can go paperless without providing an email address.
        // Make email required if user has selected to go paperless
        this.$validator.fields.find({name: 'email'}).rules.required = this.model.statementEmails
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.$emit('on-submit', this.model)
            this.register()
          }
        })
      },
      viewClient: viewClientMethod,
      accountSelector: accountSelectorMethod,
      register: function () {
        this.$http.post('/client/register', this.model)
          .then(response => {
            if (response.data.authenticated) {
              if (response.data.accounts) {
                this.accountSelector(response.data.accounts)
              } else {
                this.viewClient(response.data)
              }
            } else {
              this.serverError = response.data.error
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    created: function () {
      this.viewClient = this.viewClient.bind(this)
      this.accountSelector = this.accountSelector.bind(this)
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Home/Forms/AccountSetup.vue